import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Tabs, Tab } from "@material-ui/core";
import moment from "moment";
import EventCard from "../components/EventCard";
import EnhancedTable from "../components/Table";
import PastEventsTable from "../components/PastEventsTable";
import { request } from "../../../services/helpers";
import RespondentDialog from "../components/respondentsDialog";
import MarketingDialog from "../components/MarketingDialog";
import InviteNotificationForm from "../components/InviteNotificationForm";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: "100%",
      width: "100%",
      backgroundColor: "#000",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles(() => ({
  root: {
    textTransform: "none",
    "&:focus": {
      opacity: 1,
      background: "#fff7de",
      border: "0px",
    },
    "&$selected": {
      opacity: 1,
      background: "#fff7de",
      border: "0px",
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const EventDashboard = (props) => {
  const [events, setEvents] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [completedEvents, setCompletedEvents] = useState([]);
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [showAllPastEvents, setShowAllPastEvents] = useState(false);
  const [showAllCompletedEvents, setShowAllCompletedEvents] = useState(false);
  const [error, setError] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [peopleDialogOpen, setPeopleDialogOpen] = useState(false);
  const [marketingDialogOpen, setMarketingDialogOpen] = useState(false);
  const [notifDialogOpen, setNotifDialogOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [currentEventTitle, setCurrentEventTitle] = useState(null);
  const [rsvpCounts, setRsvpCounts] = React.useState({});
  const [ratings, setRatings] = React.useState({});
  const fetchRsvpCount = async () => {
    const tempObj = {};
    for (let i = 0; i < allEvents.length; i++) {
      const res = await request.get(`/event/rsvp-count/${allEvents[i]._id}`);
      tempObj[allEvents[i]._id] = parseInt(res.data);
    }
    const finalObj = { ...tempObj };
    setRsvpCounts(finalObj);
  };

  const fetchRatings = async () => {
    const tempObj = {};
    for (let i = 0; i < allEvents.length; i++) {
      let formData = { eventId: allEvents[i]._id };
      const res = await request.post(`/event/rating`, formData);
      if(res && res.data && res.data.avgRating){
        tempObj[allEvents[i]._id] = parseInt(res.data.avgRating);
      }else{
        tempObj[allEvents[i]._id] = null;
      }
    }
    let finalResult = { ...tempObj };
    setRatings(finalResult);
  };
  const handlePeopleDialogOpen = (eventId, eventTitle) => {
    setCurrentEvent(eventId);
    setCurrentEventTitle(eventTitle);
    setNotifDialogOpen(false);
    setPeopleDialogOpen(true);
  };
  const handlePeopleDialogClose = () => {
    setPeopleDialogOpen(false);
  };

  const handleNotifDialogOpen = (eventId, eventTitle) => {
    setCurrentEvent(eventId);
    setCurrentEventTitle(eventTitle);
    setPeopleDialogOpen(false);
    setNotifDialogOpen(true);
  };
  const handleNotifDialogClose = () => {
    setNotifDialogOpen(false);
  };

  const handleMarketingDialogOpen = () => {
    if (selectedEvents.length > 0) {
      setMarketingDialogOpen(true);
    }
  };
  const handleMarketingDialogClose = () => {
    setMarketingDialogOpen(false);
  };

  const getEventsForIds = (ids) => {
    const tempEvents = [];
    ids.forEach((id) => {
      completedEvents.forEach((event) => {
        if (event._id === id) {
          tempEvents.push(event);
        }
      });
    });
    setSelectedEvents(tempEvents);
  };

  const handleLimitChange = (type) => {
    switch (type) {
      case "all":
        setShowAllEvents(!showAllEvents);
        break;
      case "completed":
        setShowAllCompletedEvents(!showAllCompletedEvents);
        break;
      case "past":
        setShowAllPastEvents(!showAllPastEvents);
        break;
    }
  };

  const fetchEvents = async () => {
    try {
      const res = await request.get("/event/list?past=true");
      const allEvents = res.data;
      setAllEvents(res.data);
      const live = allEvents.filter((event) => event.eventStatus.live);
      const upcoming = allEvents.filter((event) => event.eventStatus.pre);
      const past = allEvents.filter((event) => {
        return (
          new Date(event.eventEndDate) <
          new Date(moment(new Date()).subtract(1, "days"))
        );
      });
      const completed = allEvents.filter(
        (event) =>
          new Date(event.eventEndDate) < new Date() &&
          new Date(event.eventEndDate) >
            new Date(moment(new Date()).subtract(1, "days"))
      );
      setLiveEvents(live);
      setPastEvents(past);
      setCompletedEvents(completed);
      setUpcomingEvents(upcoming);
      return true;
    } catch (e) {
      setError(e);
      return false;
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  useEffect(() => {
    fetchRatings();
    fetchRsvpCount();
  }, [allEvents]);

  useEffect(() => {
    switch (currentTab) {
      case 0:
        setEvents(liveEvents);
        break;
      case 1:
        setEvents(upcomingEvents);
        break;
    }
  }, [currentTab, liveEvents, upcomingEvents]);

  return (
    <div className="py-8 md:px-16 bg-gray-100">
      <div className="lg:flex items-center justify-between px-4 md:px-0">
        <div className="text-4xl font-rubik font-bold leading-10">
          <h1>Event </h1>
          <h1>Dashboard</h1>
        </div>
      </div>
      <div className="py-8">
        <div className="flex">
          <StyledTabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="styled tabs example"
          >
            <StyledTab label="live" />
            <StyledTab label="upcoming" />
          </StyledTabs>
        </div>
      </div>
      <div className="py-8 md:px-0 px-4 flex flex-wrap grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2 md:grid-cols-3 md:gap-4 md:w-7/12 w-full">
        {showAllEvents
          ? events.map((l, i) => (
              <EventCard
                key={i}
                id={l._id}
                name={l.speakerDetails.name}
                title={l.eventName}
                credentials={l.speakerDetails.credential}
                image={l.eventBanner}
                num_attendees={rsvpCounts[l._id]}
                openDialog={handlePeopleDialogOpen}
                openNotifDialog={handleNotifDialogOpen}
                date={moment(l.eventDate).format("D MMM").toUpperCase()}
              />
            ))
          : events
              .slice(0, Math.min(3, events.length))
              .map((l, i) => (
                <EventCard
                  key={i}
                  id={l._id}
                  name={l.speakerDetails.name}
                  title={l.eventName}
                  credentials={l.speakerDetails.credential}
                  image={l.eventBanner}
                  num_attendees={rsvpCounts[l._id]}
                  openDialog={handlePeopleDialogOpen}
                  openNotifDialog={handleNotifDialogOpen}
                  date={moment(l.eventDate).format("D MMM").toUpperCase()}
                />
              ))}
      </div>
      <div className="pb-8 md:px-4 px-8">
        <button
          className="bg-transparent text-xs border-b-2 border-black"
          onClick={() => {
            handleLimitChange("all");
          }}
        >
          {showAllEvents ? "SHOW LESS" : "SHOW ALL"}
        </button>
      </div>
      <div className="py-8 md:px-0 px-4  md:w-3/4 w-full">
        <div className="border-b-2 border-gray-300 pb-2">
          <h3 className="font-normal text-lg">Recently Completed</h3>
        </div>
        <div className="pt-4">
          <EnhancedTable
            limit={showAllCompletedEvents}
            events={completedEvents}
            rsvpCounts={rsvpCounts}
            getEventsForIds={getEventsForIds}
          />
        </div>
      </div>
      <div className="pb-8 md:px-4 px-8 flex justify-between md:w-3/4 w-full">
        <div>
          <button
            className="bg-transparent text-xs border-b-2 border-black"
            onClick={() => {
              handleLimitChange("completed");
            }}
          >
            {showAllCompletedEvents ? "SHOW LESS" : "SHOW ALL"}
          </button>
        </div>
        <div>
          <button
            className={
              selectedEvents.length > 0
                ? "bg-transparent text-xs font-bold"
                : "bg-transparent text-xs text-gray-500 font-bold"
            }
            onClick={handleMarketingDialogOpen}
          >
            ADD MARKETING
          </button>
        </div>
      </div>
      <div className="py-8 md:px-0 px-4  md:w-3/4 w-full">
        <div className="border-b-2 border-gray-300 pb-2">
          <h3 className="font-normal text-lg">Previous</h3>
        </div>
        <div className="pt-4">
          <PastEventsTable
            events={pastEvents}
            limit={showAllPastEvents}
            ratings={ratings}
            rsvpCounts={rsvpCounts}
          />
        </div>
      </div>
      <div className="pb-8 md:px-4 px-8">
        <button
          className="bg-transparent text-xs border-b-2 border-black"
          onClick={() => {
            handleLimitChange("past");
          }}
        >
          {showAllPastEvents ? "SHOW LESS" : "SHOW ALL"}
        </button>
      </div>
      <RespondentDialog
        eventId={currentEvent}
        eventName={currentEventTitle}
        handleClose={handlePeopleDialogClose}
        open={peopleDialogOpen}
        num_attendees={rsvpCounts[currentEvent]}
      />
      <InviteNotificationForm
        eventId={currentEvent}
        eventName={currentEventTitle}
        handleClose={handleNotifDialogClose}
        open={notifDialogOpen}
      />
      <MarketingDialog
        events={selectedEvents}
        handleClose={handleMarketingDialogClose}
        open={marketingDialogOpen}
      />
    </div>
  );
};

export default EventDashboard;
